<template>
  <section class="customerOwnedAwsAccountsView">
    <v-container fluid class="header">
      <v-layout row>
        <v-flex xs12 sm12 md12>
          <material-card
            color="orange"
            title="Register Customer Owned Accounts List">
            <v-container fluid class="request-list">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card>
                    <!-- Loading State -->
                    <v-card-text v-if="isLoading" class="text-center">
                      <v-progress-circular indeterminate color="primary" />
                      <p>Loading your requests...</p>
                    </v-card-text>

                    <!-- Empty State -->
                    <v-card-text v-else-if="requests.length === 0" class="text-center">
                      <v-icon large color="grey">mdi-information-outline</v-icon>
                      <p class="mt-3">You have not submitted any customer owned accounts requests yet.</p>
                      <v-btn
                        color="primary"
                        @click="goToRegister"
                        class="mt-2"
                      >
                        Register New Account
                      </v-btn>
                    </v-card-text>

                    <!-- Requests Table -->
                    <div v-else>
                      <v-data-table
                        :headers="headers"
                        :items="requests"
                        :pagination.sync="pagination"
                        class="elevation-0"
                        hide-default-footer
                        hide-actions
                      >
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td class="justify-center layout px-0">
                              <v-icon small @click="viewRequest(props.item)">
                                visibility
                              </v-icon>
                            </td>
                            <!-- <td>{{ props.item.customer_owned_id }}</td> -->
                            <td>{{ props.item.opportunityId }}</td>
                            <td>{{ props.item.customerName }}</td>
                            <td v-html="formatAwsAccountIds(props.item.awsAccountIds)"></td>
                            <td>{{ props.item.requestManagedServices === 'true' ? 'Yes' : 'No' }}</td>
                            <td>{{ props.item.status || 'Pending' }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                      <div class="text-xs-center mt-3" >
                        <v-btn :disabled="!nextPageKey" small @click="showNextData">LOAD MORE...</v-btn>
                      </div>
                    </div>

                    <!-- Action Buttons -->
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="primary"
                        @click="goToRegister"
                      >
                        Register New Account
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Request Details Dialog -->
    <v-dialog v-model="showDialog" max-width="800">
      <v-card v-if="selectedRequest">
        <v-card-title>
          <span class="headline">Request details</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-list two-line>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Opportunity ID</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.opportunityId }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Customer Name</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.customerName }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>AWS Account IDs</v-list-tile-title>
                <v-list-tile-sub-title v-html="formatAwsAccountIds(selectedRequest.awsAccountIds)"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Supporting PDL</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.supportingPdl }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Contact</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.contactName }} — {{ selectedRequest.contactEmail }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Managed Services Requested</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.requestManagedServices ==='true' ? 'Yes' : 'No' }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar v-if="selectedRequest.requestManagedServices === 'true'">
              <v-list-tile-content>
                <v-list-tile-title>WBS Code</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.wbsCode }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar v-if="selectedRequest.requestManagedServices === 'true'">
              <v-list-tile-content>
                <v-list-tile-title>Target Deployment Date</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.targetDeploymentDate }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Customization Description</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedRequest.customizationDescription }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ViewCustomerOwnedAwsAccounts',
  data () {
    return {
      headers: [
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Opportunity ID',
          align: 'left',
          value: 'opportunityId'
        },
        {
          text: 'Customer Name',
          align: 'left',
          value: 'customerName'
        },
        {
          text: 'AWS Account IDs',
          align: 'left',
          value: 'awsAccountIds'
        },
        {
          text: 'Request Managed Services',
          align: 'left',
          value: 'requestManagedServices'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status'
        }
      ],
      showDialog: false,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'customer_owned_id',
        descending: true
      }
    }
  },
  computed: {
    ...mapState('user/registerCustomerOwnedAccts', [
      'requests',
      'isLoading',
      'selectedRequest',
      'nextPageKey'
    ])
  },
  mounted () {
    this.fetchRequests()
  },
  methods: {
    ...mapActions('user/registerCustomerOwnedAccts', [
      'fetchRequests'
    ]),
    goToRegister () {
      this.$router.push('/register-customer-owned-accts/new')
    },
    viewRequest (request) {
      this.$store.commit('user/registerCustomerOwnedAccts/setSelectedRequest', request)
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
      this.$store.commit('user/registerCustomerOwnedAccts/setSelectedRequest', null)
    },
    showNextData () {
      this.pagination.rowsPerPage = this.requests.length + this.pagination.rowsPerPage
      if (this.nextPageKey) {
        this.fetchRequests({ nextPageKey: this.nextPageKey })
      }
    },
    formatAwsAccountIds (awsAccountIds) {
      let accountItems = awsAccountIds

      if (typeof accountItems === 'string') {
        try {
          accountItems = JSON.parse(accountItems)
        } catch (e) {
          return accountItems
        }
      }
      if (!Array.isArray(accountItems)) {
        return ''
      }

      return accountItems
        .map(item => (item.aws_account_id || item.accountId || '').toString().trim())
        .filter(Boolean)
        .join(', ')
    }
  }
}
</script>

<style scoped lang="scss">
.customerOwnedAwsAccountsView {
  padding: 20px 0;

  .header {
    margin-bottom: 20px;
    h3 {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }
  }

  .request-list {
    .v-card {
      border-radius: 4px;
    }

    .v-data-table {
      width: 100%;
    }

    .text-center {
      text-align: center;
      padding: 40px 20px;
    }
  }
}
</style>
